import axios from 'src/utils/axios';

export const GET_TOTAL_STAFF = '@user/get-total-staff';
export const GET_ALL_STAFF = '@user/get-all-staff';
export const ADD_STAFF = '@user/add-staff';
export const UPDATE_STAFF = '@user/update-staff';
export const DELETE_STAFF = '@user/delete-staff';
export const RESET_PASSWORD = '@user/reset-password';

export function addStaffsByWorkspace(staffEmails, workspaceId) {
  const request = axios.post(`/api/staff/addStaffsToWorkspace`, {
    staffEmails,
    workspaceId
  });

  return dispatch => {
    return request.then(() => dispatch(getAllStaff(workspaceId)));
  };
}

export function syncStaffsByWorkspace(staffEmails, workspaceId) {
  const request = axios.post(`/api/workspaces/sync-staffs`, {
    staffEmails,
    workspaceId
  });

  return dispatch => {
    return request.then(() => dispatch(getAllStaff(workspaceId)));
  };
}

export function getTotalStaff() {
  const request = axios.get(`/api/staff/all`);

  return dispatch => {
    return request.then(response =>
      dispatch({
        type: GET_TOTAL_STAFF,
        payload: response.data
      })
    );
  };
}

export function getWorkspaceStaff(workspaceId) {
  const request = axios.post(`/api/staff/all`, { workspaceId });

  return dispatch => {
    return request.then(response =>
      dispatch({
        type: GET_ALL_STAFF,
        payload: response.data
      })
    );
  };
}

// Backward-compatible alias for workspace-scoped staff loading.
export function getAllStaff(workspaceId) {
  return getWorkspaceStaff(workspaceId);
}

export function addOneStaff(staff, workspaceId) {
  const request = axios.post(`/api/staff/add`, { staff, workspaceId });
  return dispatch => {
    return request.then(response =>
      dispatch({
        type: ADD_STAFF,
        payload: response.data
      })
    );
  };
}

export function updateStaff(staff) {
  const request = axios.put(`/api/staff/update`, {
    staff
  });
  return dispatch => {
    return request.then(response =>
      dispatch({
        type: UPDATE_STAFF,
        payload: response.data
      })
    );
  };
}

export function deleteStaffs(id) {
  const request = axios.delete(`/api/staff/delete/${id}`);

  return dispatch => {
    return request.then(() =>
      dispatch({
        type: DELETE_STAFF,
        payload: { id }
      })
    );
  };
}

export function getGlobalStaff() {
  const request = axios.get(`/api/staff/global`);

  return dispatch => {
    return request.then(response =>
      dispatch({
        type: GET_TOTAL_STAFF,
        payload: response.data
      })
    );
  };
}

export function removeStaffFromWorkspace(workspaceId, userId) {
  const request = axios.delete(`/api/workspaces/user/${workspaceId}/${userId}`);

  return dispatch => {
    return request.then(() => dispatch(getAllStaff(workspaceId)));
  };
}

export function resetPassword(staff, workspaceId) {
  const request = axios.put(`/api/staff/resetPassword`, {
    staff,
    workspaceId
  });
  return dispatch => {
    return request.then(response =>
      dispatch({
        type: RESET_PASSWORD,
        payload: response.data
      })
    );
  };
}
